import React from 'react';

import { FlexContainer } from '../../styled';
import { BlockedWarningTitle, ChatBlockedWarningMessage } from './ChatBlockedWarningStyles';

const ChatBlockedWarning = () => {
  return (
    <ChatBlockedWarningMessage>
      <FlexContainer spaceBetween>
        <div>
          <BlockedWarningTitle>Sorry, you have been blocked by this recipient</BlockedWarningTitle>
        </div>
      </FlexContainer>
    </ChatBlockedWarningMessage>
  );
};

export default ChatBlockedWarning;
